"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConversationalSearchResultsView = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _spins = require("@site/spins");
var _reactMintl = require("@godaddy/react-mintl");
var _sparklesFilled = _interopRequireDefault(require("@ux/icon/sparkles-filled"));
var _sharedComponents = require("@site/shared-components");
var _ConversationalSearch = require("../styles/ConversationalSearch");
const ConversationalSearchResultsView = ({
  language,
  results,
  options = {},
  ctaProps,
  enableDynamicFontScaling,
  AddToCartButton,
  PriceBlock,
  spinType = 'default',
  SpinsBlock,
  hideResultsHeader,
  promptTitle,
  promptContent,
  userSearchInput,
  showDomainPrompt = false,
  showUserPrompt,
  topContentText,
  isMobile,
  isModal,
  exactBlockConfigs = {},
  exactApiResponseData,
  smartExactApiResponseData,
  resultsHeadingTextId = 'results'
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const {
    ExactMatchBlock,
    exactBlockMode
  } = exactBlockConfigs;
  const {
    showFreeIndicator,
    maxSpins = 40
  } = options;
  const getExactMatch = () => {
    return ExactMatchBlock && /*#__PURE__*/_react.default.createElement(_sharedComponents.ErrorBoundary, {
      fallback: null
    }, /*#__PURE__*/_react.default.createElement(ExactMatchBlock, {
      exactApiResponseData: exactApiResponseData,
      smartExactApiResponseData: smartExactApiResponseData,
      spinsGenAiResults: results,
      exactBlockMode: exactBlockMode
    }));
  };
  const getSpinPriceOptions = fqdn => ({
    ...options,
    classNames: options?.styleOverrides?.pricingStyleOverrides,
    tooltipButtonAriaLabel: formatMessage({
      id: 'ariaLabelOpenPricingTooltip'
    }, {
      product: fqdn
    }),
    itc: options?.itc
  });
  const getHeadline = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !hideResultsHeader && /*#__PURE__*/_react.default.createElement("div", {
      "data-test-id": "results-heading",
      className: "results-heading heading-font text-center"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: resultsHeadingTextId
    })), topContentText && /*#__PURE__*/_react.default.createElement("div", {
      "data-test-id": "results-top-content-text"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: topContentText
    })), /*#__PURE__*/_react.default.createElement("br", null), showUserPrompt && /*#__PURE__*/_react.default.createElement("div", {
      className: "px-2 prompt",
      "data-cy": "conversational-search-prompt"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "prompt-text ms1",
      "data-cy": "conversational-search-prompt-text"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: promptTitle || 'promptTitle'
    })), /*#__PURE__*/_react.default.createElement("h2", {
      className: "prompt-user-input ms7",
      "data-cy": "conversational-search-prompt-user-input"
    }, "\u201C", userSearchInput, "\u201D"), /*#__PURE__*/_react.default.createElement("span", {
      className: "prompt-content",
      "data-cy": "conversational-search-prompt-content"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: promptContent || 'promptContent'
    }))));
  };
  const getSpinsBlock = () => {
    const updatedResultsRecommendedDomains = [...(results?.RecommendedDomains || [])];
    const updatedResults = {
      ...results
    };
    if (ExactMatchBlock && !exactApiResponseData) {
      if (exactBlockMode === 'topTwoResults') {
        // remove first two domains if it's top results 2 cards
        updatedResultsRecommendedDomains.shift();
      }
      updatedResultsRecommendedDomains.shift();
      updatedResults.RecommendedDomains = updatedResultsRecommendedDomains;
    }
    if (SpinsBlock) {
      return /*#__PURE__*/_react.default.createElement(SpinsBlock, {
        spinResultFiltered: updatedResults,
        responsiveContainer: false
      });
    } else if (spinType === 'tight-modern') {
      return /*#__PURE__*/_react.default.createElement(_spins.SpinsModernTightenedWithoutComponentDataProvider, {
        spinsResponse: updatedResults,
        language: language,
        options: options,
        ctaProps: ctaProps,
        enableDynamicFontScaling: enableDynamicFontScaling,
        AddToCartButton: AddToCartButton,
        PriceBlock: PriceBlock
      });
    } else if (spinType === 'default') {
      const recommendedDomains = (0, _spins.transformSpinData)({
        findResponse: updatedResults,
        showFreeIndicator,
        maxSpins
      });
      return recommendedDomains.map((domain, i) => {
        const {
          product
        } = domain;
        return /*#__PURE__*/_react.default.createElement("div", {
          key: `spin-results-container-${domain?.Fqdn}`,
          className: "spin-results-container",
          "data-test-id": `spin-results-container-${domain?.Fqdn}`
        }, showDomainPrompt && i === 0 && /*#__PURE__*/_react.default.createElement("div", {
          className: "domain-prompt-text font-weight-bold"
        }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
          id: "domainPrompt",
          values: {
            domain: domain?.Fqdn
          }
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "d-flex align-items-center"
        }, /*#__PURE__*/_react.default.createElement(_sparklesFilled.default, {
          className: "sparkles-filled-icon"
        }), /*#__PURE__*/_react.default.createElement("span", {
          className: "ml-2 sld-token-heading heading-font"
        }, domain?.SldTokens?.join(' '))), /*#__PURE__*/_react.default.createElement("div", {
          className: "spin-results-div",
          "data-cy": "conversational-search-spin-result"
        }, /*#__PURE__*/_react.default.createElement(_spins.SpinResults, {
          language: language,
          dataCy: `spin-results-${domain?.Fqdn}`,
          product: product,
          domainEntry: domain,
          ctaProps: ctaProps,
          options: options,
          enableDynamicFontScaling: enableDynamicFontScaling,
          customAddToCartButton: AddToCartButton && /*#__PURE__*/_react.default.createElement(AddToCartButton, {
            domain,
            product,
            isConversationalSearch: true,
            dataEid: "find.sales.aisearch"
          }),
          PriceBlock: PriceBlock && /*#__PURE__*/_react.default.createElement(PriceBlock, {
            domain,
            product,
            options: getSpinPriceOptions(domain?.Fqdn),
            enableDynamicFontScaling
          })
        })));
      });
    }
  };
  const getDataCy = () => {
    if (SpinsBlock) return '-spins-block';
    if (spinType === 'tight-modern') return '-modern';
    return '';
  };
  return /*#__PURE__*/_react.default.createElement(_ConversationalSearch.StyledConversationalResultsView, {
    "data-cy": `conversational-search-results-view${getDataCy()}`,
    "data-testid": `conversational-search-results-view${getDataCy()}`,
    isMobile: isMobile,
    isModal: isModal,
    showExactMatchBlock: !!ExactMatchBlock,
    showResultsHeading: spinType === 'default'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "conversational-search-results-view",
    "data-testid": "conversational-search-results-view"
  }, getHeadline(), getExactMatch(), getSpinsBlock()));
};
exports.ConversationalSearchResultsView = ConversationalSearchResultsView;
ConversationalSearchResultsView.propTypes = {
  language: _propTypes.default.object.isRequired,
  results: _propTypes.default.object,
  ctaProps: _propTypes.default.object,
  options: _propTypes.default.object,
  enableDynamicFontScaling: _propTypes.default.bool,
  AddToCartButton: _propTypes.default.func,
  spinType: _propTypes.default.oneOf(['default', 'tight-modern']),
  SpinsBlock: _propTypes.default.func,
  PriceBlock: _propTypes.default.func,
  hideResultsHeader: _propTypes.default.bool,
  promptTitle: _propTypes.default.string,
  promptContent: _propTypes.default.string,
  userSearchInput: _propTypes.default.string,
  showDomainPrompt: _propTypes.default.bool,
  topContentText: _propTypes.default.string,
  showUserPrompt: _propTypes.default.bool,
  isMobile: _propTypes.default.bool,
  isModal: _propTypes.default.bool,
  exactBlockConfigs: _propTypes.default.shape({
    ExactMatchBlock: _propTypes.default.func,
    exactBlockMode: _propTypes.default.string
  }),
  exactApiResponseData: _propTypes.default.object,
  smartExactApiResponseData: _propTypes.default.object,
  resultsHeadingTextId: _propTypes.default.string
};